import { render, staticRenderFns } from "./ChangeQuotationStatus.vue?vue&type=template&id=418341f6&scoped=true&"
import script from "./ChangeQuotationStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeQuotationStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeQuotationStatus.vue?vue&type=style&index=0&id=418341f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418341f6",
  null
  
)

export default component.exports